import LoginCompo from '../features/Auth/components/LoginCompo'
import { GoogleOAuthProvider } from '@react-oauth/google';

function LoginPage() {
   return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
         <LoginCompo />
      </GoogleOAuthProvider>
   );
}

export default LoginPage;